"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditRentersClaimsPriceOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var EditRentersClaimsPriceOutputWidget = /** @class */ (function (_super) {
    __extends(EditRentersClaimsPriceOutputWidget, _super);
    function EditRentersClaimsPriceOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.paymentRequired = _this.props.interaction.factors.additionalPremium > 0;
        _this.refundRequired = _this.props.interaction.factors.returnPremium > 0;
        _this.state = {};
        return _this;
    }
    EditRentersClaimsPriceOutputWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies(services_1.ProductsEnum.RENTERS).subscribe(function (policies) { return _this.setState({ policies: policies }); });
    };
    EditRentersClaimsPriceOutputWidget.prototype.render = function () {
        if (this.state.policies) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center", children: [(0, jsx_runtime_1.jsxs)("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2", children: [this.paymentRequired && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium) }), this.refundRequired && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium) })] }), (0, jsx_runtime_1.jsxs)("div", { children: [this.paymentRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["to change ", (0, jsx_runtime_1.jsx)("b", { className: "font-weight-semi-bold", children: this.renderWhatChangedWording() })] }), this.refundRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["you will get refund to change ", (0, jsx_runtime_1.jsx)("b", { className: "font-weight-semi-bold", children: this.renderWhatChangedWording() })] }), !this.paymentRequired && !this.refundRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Great news! There is no extra cost to change ", this.renderWhatChangedWording()] })] })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    EditRentersClaimsPriceOutputWidget.prototype.renderWhatChangedWording = function () {
        var prevClaimsLength = this.state.policies[0].interaction.policyHolder.claims.length;
        var newClaimsLength = this.props.interaction.policyHolder.claims.length;
        var changes = "the number of claims in the last 5 years from ".concat(prevClaimsLength, " to ").concat(newClaimsLength);
        changes = changes.replace("0", "none");
        window.sessionStorage.removeItem("mtaEditRentersClaimsChanges");
        window.sessionStorage.setItem("mtaEditRentersClaimsChanges", changes);
        return changes;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], EditRentersClaimsPriceOutputWidget.prototype, "customerPortalService", void 0);
    return EditRentersClaimsPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.EditRentersClaimsPriceOutputWidget = EditRentersClaimsPriceOutputWidget;
//# sourceMappingURL=EditRentersClaimsPriceOutputWidget.js.map